// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackPageViewParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPageView";
import { RecursivePartial } from "@toolkit/Framework/Types/Common";

/* Greif Custom Code - Start */
import * as storeHooks from "@store/Framework/GoogleAnalytics/hooks";
import * as storeTrackers from "@store/Framework/GoogleAnalytics/trackers";
/* Greif Custom Code - End */

const baseGA = { ...ga };

Object.assign<Toolkit.GoogleAnalytics, RecursivePartial<Toolkit.GoogleAnalytics>>(ga, {
    /* Greif Custom Code - Start */
    track: { ...ga.track, ...storeTrackers },
    use: { ...ga.use, ...storeHooks },
    /* Greif Custom Code - End */
});
